import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypePlanoContas } from "../../Models/Financeiro/PlanoContas";
import { useQuery } from "@tanstack/react-query";
import RequestUtilitario, { BasicQueryType } from "../../Utils/RequisicaoUtilitario";

export class PlanoContasService {
    public listar(plano: TypePlanoContas): Promise<AxiosResponse<TypePlanoContas[]>> {
        return Axios.post<TypePlanoContas[]>(`PlanoContas/listar`, plano);
    }

    public inserir(plano: TypePlanoContas){
        return Axios.post<boolean>(`PlanoContas/inserir`, plano);
    }

    public atualizar(plano: TypePlanoContas){
        return Axios.post<boolean>(`PlanoContas/atualizar`, plano);
    }

    public desativar(codigo: number){
        return Axios.patch<boolean>(`PlanoContas/${codigo}/desativar/`);
    }

    public ativar(codigo: number){
        return Axios.patch<boolean>(`PlanoContas/${codigo}/ativar/`);
    }
}

export function useListarPlanoDeContas ({
    planoDeContas,
    ...rest
}:BasicQueryType<AxiosResponse<TypePlanoContas[]>, {
    planoDeContas?:TypePlanoContas
}>) {
    const planoContasServices = new PlanoContasService();

    return useQuery({
        ...rest,
        queryKey : [ "Financeiro", "PlanoContas", "ListarTodos", RequestUtilitario.objectToQueryString({ planoDeContas }) ],
        queryFn : () => planoContasServices.listar(planoDeContas ?? {}),
        select : ({data}) => {
            return data.map(m => {
                if ((m.dataCricacao ?? null) !== null) m.dataCricacao = new Date(m.dataCricacao!);

                return m;
            });
        }
    });
}

export default {
    useListarPlanoDeContas
}